export default "__VITE_ASSET__BY7BjMKu__"